import { render } from "./CardHelp.vue?vue&type=template&id=294fd4c2&ts=true"
import script from "./CardHelp.vue?vue&type=script&lang=ts"
export * from "./CardHelp.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__